import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconPrescriptionBonus = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M17.166 33.173h8.733a.5.5 0 1 1 0 1h-8.733a.5.5 0 1 1 0-1M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24m-10.827 4.511a7.184 7.184 0 0 0 0-10.598V9.43a1 1 0 0 0-1-1H11.827a1 1 0 0 0-1 1v33.406C14.561 45.457 19.102 47 24 47s9.439-1.543 13.173-4.163zM17.538 16.487a.13.13 0 0 0 .18 0c.408-.4 2.063-2.032 2.391-2.46.255-.33.505-.728.505-1.17v-.012a1.9 1.9 0 0 0-.195-.877 1.43 1.43 0 0 0-.554-.587 1.65 1.65 0 0 0-.84-.21 1.54 1.54 0 0 0-.67.141 1.24 1.24 0 0 0-.486.401c-.128.18-.21.387-.24.605v.001a1.37 1.37 0 0 0-.24-.605 1.24 1.24 0 0 0-.487-.4 1.54 1.54 0 0 0-.67-.142 1.65 1.65 0 0 0-.84.21c-.237.138-.43.342-.554.588a1.9 1.9 0 0 0-.195.876v.01c.002.44.25.84.505 1.169.329.43 1.983 2.062 2.39 2.462m13.296 22.556H17.166a.5.5 0 1 0 0 1h13.668a.5.5 0 1 0 0-1m7.671-15.831c0 3.425-2.786 6.21-6.21 6.21s-6.212-2.785-6.212-6.21 2.787-6.21 6.211-6.21 6.211 2.785 6.211 6.21M29.964 21a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2m4.806-.45a.501.501 0 0 0-.837-.547L30.05 25.96a.502.502 0 0 0 .838.547zm.687 5.56a.6.6 0 1 0-1.2 0 .6.6 0 0 0 1.2 0',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconPrescriptionBonus)
export default ForwardRef
